<!-- Generic Edit Part Dialog -->
@if (Visible) {
  <div class="edit-part-dialog-overlay" (click)="cancel()">
    <div class="edit-part-dialog" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="dialog-header">
        <div class="header-icon">
          <i [class]="getIcon()"></i>
        </div>
        <h3>{{ getDialogTitle() }}</h3>
        <button class="close-button" (click)="cancel()">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>
      <!-- Content -->
      <div class="dialog-content">
        <!-- Loading state -->
        @if (IsLoading) {
          <div class="loading-state">
            <i class="fa-solid fa-spinner fa-spin"></i>
            <span>Loading configuration panel...</span>
          </div>
        }
        <!-- Error state -->
        @if (LoadError && !IsLoading) {
          <div class="error-state">
            <i class="fa-solid fa-exclamation-triangle"></i>
            <span>{{ LoadError }}</span>
          </div>
        }
        <!-- Dynamic config panel container -->
        <ng-container #configPanelContainer></ng-container>
      </div>
      <!-- Footer -->
      <div class="dialog-footer">
        <button
          class="btn-primary"
          (click)="save()"
          [disabled]="!IsValid || IsLoading || LoadError">
          <i class="fa-solid fa-check"></i>
          {{ getSaveButtonText() }}
        </button>
        <button class="btn-secondary" (click)="cancel()">
          Cancel
        </button>
      </div>
    </div>
  </div>
}
